@if (isLoading) {
  <label>Loading...</label>
}

@if (column && record) {
  <p-select
    [options]="options"
    [(ngModel)]="selectedOption"
    [optionLabel]="optionLabelName"
    (ngModelChange)="onModelChange($event)"
    [required]="column.validation?.isRequired === true"
    #ddValue="ngModel"
    id="dropdownEditor"
    [filter]="true"
    filterBy="name"
    [style]="{'width':'100%'}">
    <ng-template pTemplate="filter" let-options="options">
      <input
        id="dropdownSearchInput"
        type="text"
        pInputText
        placeholder="Search..."
        [pAutoFocus]="true"
        (keyup)="onFilterChanged($event, options)" />
      </ng-template>
    </p-select>
  }

  <!--<div *ngIf="ddValue.invalid && (ddValue.dirty || ddValue.touched)"
  class="alert">
  <div *ngIf="ddValue.errors?.['required']">
    Required.
  </div>
</div>-->
